<template>
  <div>
    <div v-if="model.status == 14">
      <b-form-group :label="$t('tracking.cargo.disapprovedDescriptionSolution')">
        <b-form-textarea
          id="DisapprovedDescriptionSolution"
          type="text"
          :placeholder="$t('tracking.cargo.disapprovedDescriptionSolution')"
          v-model="model.disapprovedDescriptionSolution"
          :readonly="readonly"
        />
      </b-form-group>
      <b-row class="text-center" v-if="model.disapprovedAttachment != null">
        <b-col>
          <base-attachment-item
            :attachment="model.disapprovedAttachment"
            :discard-visible="true"
            @discard="fileRemove"
          >
          </base-attachment-item>
        </b-col>
      </b-row>
      <div>
        <camera-button :lang="$i18n.locale" @update-image-src="updateImageSrc">
        </camera-button>
      </div>
      <div v-for="value in values" :key="value.id">
        <b-row v-if="value.active == true && value.fieldName != null">
          <b-col>
            <base-row-detail
              :label="value.fieldName"
              :value="`${value.value}`"
            ></base-row-detail>
          </b-col>
        </b-row>
      </div>
      <!-- {{model.occurrences}} -->
    </div>
    <div v-else>
      <!-- LoadingEndDate -->
      <b-form-group
        label="Data de fim do carregamento"
        label-for="LoadingEndDate"
      >
        <b-form-input
          id="LoadingEndDate"
          type="date"
          placeholder="Data de fim do carregamento"
          v-model="model.loadingEndDate"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingEndDate']">
          {{ modelstate["LoadingEndDate"][0] }}
        </span>
      </b-form-group>
      <!-- LoadingEndHour -->
      <b-form-group
        label="Hora de fim do carregamento"
        label-for="LoadingEndHour"
      >
        <b-form-input
          id="LoadingEndHour"
          type="time"
          placeholder="Hora de fim do carregamento"
          v-model="model.loadingEndHour"
          :readonly="readonly"
        />
        <span class="text-danger" v-if="modelstate['LoadingEndHour']">
          {{ modelstate["LoadingEndHour"][0] }}
        </span>
      </b-form-group>
    </div>
  </div>
</template>
<script>
import AwesomeMask from "awesome-mask";
import CargoOccurrenceAttachments from "@/components_rms/tracking/cargo/CargoOccurrenceAttachments.vue";
import BaseAttachmentItem from "@/components_rms/base/BaseAttachmentItem.vue";
import CameraButton from "@/components_rms/CameraButton.vue";
import BaseRowDetail from "@/components_rms/base/BaseRowDetail.vue";

export default {
  name: "CargoCrudData",
  components: {
    CargoOccurrenceAttachments,
    BaseAttachmentItem,
    CameraButton,
    BaseRowDetail,
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    model: Object,
    modelstate: Object,
    readonly: Boolean,
  },
  data() {
    return {
      disapprovedOptions: [],
      values: [],
    };
  },
  created() {
    this.newModel();
    this.getAllCustomValue(this.model.occurrences);
  },
  methods: {
    updateImageSrc(newValue) {
      this.model.disapprovedAttachment = newValue;
      this.$forceUpdate();
    },
    fileRemove() {
      this.model.disapprovedAttachment = null;
      this.$forceUpdate();
    },
    newModel() {
      if (this.model.disapprovedDescriptionSolution != "")
        this.model.disapprovedDescriptionSolution = "";
      if (this.model.disapprovedAttachment != "")
        this.model.disapprovedAttachment = null;
      this.$forceUpdate();
    },
    getAllCustomValue(occurrence) {
      occurrence.forEach((items) => {
        items.values.forEach((value) => {
          this.values.push(value);
          this.values.sort(function (a, b) {
            if (a.sequenceNumber < b.sequenceNumber) return -1;
            else return true;
          });
        });
      });
      // console.log(this.values);
    },
  },
};
</script>
